const isVRReady = () => {
    return window.DeviceOrientationEvent && "ontouchstart" in window;
};

export default isVRReady;
